import React, {useState, useEffect} from 'react';
import { Typography, Button, Select, MenuItem, Alert, Radio, Box, FormControlLabel, FormControl, RadioGroup, Checkbox } from '@mui/material';
import '../styles/common.css';
import { getCurrencyList, getIpBasedCurrency, getDenominationsList, createPaymentIntent } from './redux/actions';
import ErrorInfo from '../assets/error-info.svg';
import langDetails from '../components/MultiLanguage/language.json';
import SliderComponent from './SliderComponent';
import {signInWithPopup,} from "firebase/auth";
import { auth, googleProvider, facebookProvider } from "../firebase";

const DonationCost = ({ handleNext, sharedData, updateSharedData, showFrequency }) => {
  const [amountArray, setAmountArray] = useState([])
  const [active, setActive] = useState(sharedData?.donationAmount?.btnAmount  || '');
  const [amount, setAmount] = useState(sharedData?.donationAmount?.amount  || null);
  const [youGive, setYouGive] = useState(sharedData?.donationAmount?.youGive  || 0);
  const [creditApplied, setCreditApplied] = useState(sharedData?.rewardApplied?.creditApplied || 0);
  const [countryCode, setCountryCode] = useState('')
  const[errorMessage, setErrorMessage] = useState('');
  const[errMessage, setErrMessage] = useState('');
  const [ipBasedCurrency, setIpBasedCurrency] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [sliderValue, setSliderValue] = useState(sharedData?.donationAmount?.givesomeTipPercentage ? sharedData?.donationAmount?.givesomeTipPercentage : sharedData?.donationAmount?.givesomeTipPercentage === 0 ? 0 : 15);
  const [totalAmount, setTotalAmount] = useState(sharedData?.donationAmount?.totalAmount || (creditApplied + Number(youGive)) || 0);
  const [value, setValue] = useState("");
  const [recurringAcknowledged, setRecurringAcknowledged] = useState(false);
  const [existingSubError, setExistingSubError] = useState(false);

  const lang = langDetails[sharedData?.language];

  
  useEffect(() => {
    setSliderValue(sharedData?.donationAmount?.givesomeTipPercentage ? sharedData?.donationAmount?.givesomeTipPercentage : sharedData?.donationAmount?.givesomeTipPercentage === 0 ? 0 : 15)
    getIpBasedCurrency().then((response) => {
        // if(response.code && response.code  !== "") {
        //   return
        // }
        if (response && response.status === 200) {
            setIpBasedCurrency(response.data.currency)
        }
         else {
          setIpBasedCurrency('CAD')
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setErrorMessage(error.message);
      });

      getCurrencyList().then((response) => {
        if(response.code && response.code  !== "") {
          return
        }
        if (response && response.status === 200) {
          setCurrencyList(response.data.data)
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setErrorMessage(error.message);
      });
  }, []);

  useEffect(() => {
    if (ipBasedCurrency?.length > 0 && currencyList?.length > 0) {

      // Check if ipBasedCurrency is in the list
    const currencyExists = currencyList.some(
      (currency) => currency.currencyCode === ipBasedCurrency
    );
    const defaultCurrency = currencyExists ? ipBasedCurrency : 'USD';

      // const defaultCurrency = sharedData?.donationAmount?.currency || 'USD';

      setCurrencyList(currencyList);

      // For Current Use
      // setCountryCode(defaultCurrency);
      // setCurrency(defaultCurrency);
      // setCurrencySymbol(getCurrencySymbol(defaultCurrency));

      setCountryCode(sharedData?.donationAmount?.currency || defaultCurrency)
      setCurrency(sharedData?.donationAmount?.currency || defaultCurrency);
      setCurrencySymbol(sharedData?.donationAmount?.currency ? getCurrencySymbol(sharedData?.donationAmount?.currency) : getCurrencySymbol(defaultCurrency))
    }
  }, [ipBasedCurrency, currencyList]);

  useEffect(()=>{
    const apiReq = {
      "projectId": sharedData?.projectId,
      "vendorId": sharedData?.venorId || null
    }
    getDenominationsList(apiReq).then((response) => {
            if(response.code && response.code  !== "") {
              return
            }
            if (response && response.data && response.data.status === 200) {
              const isArtistOrInfluencer = response.data.data.isArtistOrInfluencer
              const keys = Object.keys(response.data.data);
              const denominationKeys = keys.filter(key => key.startsWith("denomination"));
              const denominationList = denominationKeys.map(key => response.data.data[key]);
               setAmountArray(denominationList);
               const updatedData = { ...sharedData, isArtistOrInfluencer };
               updateSharedData(updatedData);
            }
            if (response && response.data && response.data.status !== 200) {
              // setErrorMessage(response.data.message);
            }
          })
          .catch((error) => {
            console.error('Error fetching data:', error);
          //   setErrorMessage(error.message);
          });
  },[])


  const getCurrencySymbol = (currencyCode) => {
    const currency = currencyList?.find((item) => item.currencyCode === currencyCode);
    return currency ? currency.currencySymbol : '';
  };

  const [currency, setCurrency] = useState(sharedData?.donationAmount?.currency ? sharedData?.donationAmount?.currency : countryCode);
  const [currencySymbol, setCurrencySymbol] = useState(sharedData?.donationAmount?.currencySymbol);
  const [currencyError, setCurrencyError] = useState('');

  useEffect(()=>{
    
    if(sharedData?.donationAmount?.currencySymbol) {
      setCurrencySymbol(sharedData?.donationAmount?.currencySymbol)
    } else {
      setCurrencySymbol(getCurrencySymbol(currency))
    }
  },[currencyList, countryCode, sharedData?.donationAmount?.currencySymbol])

  const handleChange = (e) => {
    setCurrency(e.target.value);
    const filteredArray = currencyList?.filter((obj) => obj?.currencyCode === e.target.value)[0]
    setCurrencySymbol(filteredArray.currencySymbol);
    const updatedData = {
      ...sharedData,
      donationAmount: {
        ...sharedData.donationAmount,
        "currency": e.target.value,
        "currencySymbol": filteredArray.currencySymbol
      },
    };
    updateSharedData(updatedData);

    setCurrencyError('');
  };
  
const handleClick = (amount, index) => {
  setErrorMessage('');
  setErrMessage('');
  setActive(index);  // track by index
  setAmount('');
  setYouGive(Number(amount));
  setTotalAmount(Number(amount) + Number(creditApplied));

  const updatedData = {
    ...sharedData,
    donationAmount: {
      ...sharedData.donationAmount,
      youGive: Number(amount),
      amount: "",
      btnAmount: Number(amount),
    },
  };

  updateSharedData(updatedData);
};
const onChangeAmount = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/[^0-9.]/g, '');
    const parts = inputValue.split('.');
    if (parts.length > 2) {
      inputValue = parts[0] + '.' + parts[1];
    }
    if (inputValue.includes('.')) {
      const decimalPart = parts[1] || '';
      inputValue = parts[0] + '.' + (decimalPart.padEnd(2, '0').slice(0, 2));
    }
    setAmount(inputValue);
    setYouGive(inputValue);
    setActive('');
    setTotalAmount(Number(inputValue) + Number(creditApplied));
    const updatedData = {
      ...sharedData,
      donationAmount: {
        ...sharedData.donationAmount,
        youGive: inputValue,
        amount: inputValue,
        btnAmount: ''
      },
    };
    updateSharedData(updatedData);
    if (inputValue.trim().length !== '') {
      setErrorMessage('');
      setErrMessage('');
    }
  };

  const frequencyChange = (event) => {
    setValue(event.target.value);
  };

  const onDonationNext = () => {
      let isValid = false;
        if(totalAmount === 0){
        setErrMessage(lang?.pleaseChooseOREnterAmount)
        isValid = true;
      } else if (youGive < 2) {
        setErrMessage(lang?.pleaseEnterDonationAmount + currencySymbol+'2.');
        isValid = true;
      }
    if(isValid) {
      return
    }
      const donationAmount = {
      "projectId": "014",
      "amount": amount,
      "currency": currency,
      "description": "Payment For Givesome Donation",
      "totalAmount": totalAmount,
      "givesomeTip": creditApplied,
      "creditApplied": creditApplied,
      "givesomeTipPercentage":sliderValue,
      "btnAmount": Number(active),
      "youGive": youGive,
      "currencySymbol": currencySymbol,
      "tabInfo": "tab1",
      "isRecurringEnabled": showFrequency,
      "projectEndDate": "2027-12-31",
      "recurringInterval": value === 'one-time' ? 'oneTime' : value
     }
     
    const updatedData = { ...sharedData, donationAmount };
    updateSharedData(updatedData);
    sessionStorage.removeItem("sharedData");
    sessionStorage.setItem("sharedData", JSON.stringify(updatedData));

    if (showFrequency && value && value !== 'one-time') {
      const apiReq = {
        "mode": 'payment',
        "amount": totalAmount,
        "givesomeTip": creditApplied,
        "currency": currency?.toLowerCase(),
        "description": "Payment For Givesome Donation",
        "paymentMethodId": sharedData?.paymentMethodId,
        "userId": sharedData?.userId !== "None" ? sharedData?.userId : null,
        "isRecurringEnabled": showFrequency,
        "projectEndDate": donationAmount.projectEndDate,
        "recurringInterval": value === 'one-time' ? 'oneTime' : value,
        "projectId": sharedData?.projectId,
      };
      createPaymentIntent(apiReq).then((response) => {
        if (response && response.data && response.data.status === 200) {
          if (response.data.data.existingSubscription === true) {
            setExistingSubError(true);
            return;
          }
        }
        if (sharedData?.userId && sharedData?.userId !== "None") {
          handleNext(1);
        } else {
          window.parent.postMessage("switchToTab1", "*");
        }
      }).catch(() => {
        if (sharedData?.userId && sharedData?.userId !== "None") {
          handleNext(1);
        }
      });
      return;
    }

    if(sharedData?.userId && sharedData?.userId  !== "None") {
      handleNext(1);
    } else {
      // handleNext(5);
      window.parent.postMessage("switchToTab1", "*");
    }
  }

  const handleGoogleLogin = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;
    console.log("Google user:", user);

    const updatedData = {
      ...sharedData,
      userId: user.uid,
      userName: user.displayName,
      userEmail: user.email,
    };
    updateSharedData(updatedData);
    handleNext(1);
  } catch (error) {
    console.error("Google login error:", error);
  }
};

// const handleFacebookLogin = async () => {
//   try {
//     const result = await signInWithPopup(auth, facebookProvider);
//     const user = result.user;
//     console.log("Facebook user:", user);

//     const updatedData = {
//       ...sharedData,
//       userId: user.uid,
//       userName: user.displayName,
//       userEmail: user.email,
//     };
//     updateSharedData(updatedData);
//     handleNext(1);
//   } catch (error) {
//     console.error("Facebook login error:", error);
//   }
// };

const [loading, setLoading] = useState(false);

const handleFacebookLogin = async () => {
  if (loading) return;
  setLoading(true);
  try {
    const result = await signInWithPopup(auth, facebookProvider);
    const user = result.user;
    console.log("Facebook user:", user);

    const updatedData = {
      ...sharedData,
      userId: user.uid,
      userName: user.displayName,
      userEmail: user.email,
    };
    updateSharedData(updatedData);
    handleNext(1);
  } catch (error) {
    console.error("Facebook login error:", error);
  } finally {
    setLoading(false);
  }
};


  return (
    <>
      {/* <Typography className='query-head mb-40'>{lang?.howMuchWouldYouLikeToDonate}</Typography> */}
      <Typography className="query-head mb-40 mt-40">
        {lang?.howMuchWouldYouLikeToDonate}
      </Typography>

      <div style={{ textAlign: "right", marginTop: "20px", marginBottom: 10 }}>
        <Select
          value={currency}
          onChange={(e) => {
            handleChange(e);
          }}
          displayEmpty
          renderValue={(selected) => (
            <div style={{ fontSize: 12, textTransform: "uppercase" }}>
              <b>{selected}</b>
            </div>
          )}
          className={`amount-input ${currencyError !== "" ? "select-input-error" : "select-input"}`}
        >
          {currencyList?.map((item) => (
            <MenuItem key={item.currencyCode} value={item.currencyCode}>
              <div>
                {currency === item.currencyCode && (
                  <span style={{ marginRight: 5 }}>✓</span>
                )}
                <b style={{ marginRight: 10 }}>
                  {item.currencyCode.toUpperCase()}
                </b>
                <span style={{ color: "#ccc" }}>{item.currencyName}</span>
              </div>
            </MenuItem>
          ))}
        </Select>
      </div>
      <Typography className="sub-head mb-10" style={{ marginTop: "-25px" }}>
        {lang?.chooseAmount}:
      </Typography>

      <Typography className="error-message1 mb-10">{currencyError}</Typography>
      <div className="flex-space-btw mb-10">
        {amountArray?.map((amount, i) => (
          <Button
            key={i}
            className={`normal-text outlined-btn ${active === i ? "active-btn" : "normal-btn"}`}
            id={amount + "_" + i}
            onClick={() => handleClick(amount, i)}
            value={amount}
            variant="outlined"
          >
            {currencySymbol}
            {amount}
          </Button>
        ))}
      </div>
      <Typography className="sub-head mb-10 mt-20">
        {lang?.customizeAmount}:
      </Typography>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "baseline",
          marginTop: 15,
        }}
      >
        <div
          style={{
            position: "relative",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <label
            className={`${errorMessage !== "" ? "money-symbol" : "money-symbol1"}`}
            style={{ left: "36%" }}
          >
            {currencySymbol}{" "}
          </label>
          <Typography className="error-message">{errorMessage}</Typography>
          <input
            style={{ width: "100%", paddingLeft: "40%" }}
            id="customAmount"
            className={`amount-input input-center ${errorMessage !== "" ? "err-input" : ""}`}
            maxLength={amount?.includes(".") ? 11 : 8}
            value={amount}
            onChange={(e) => {
              onChangeAmount(e);
            }}
            placeholder={lang?.enterACustomAmount}
          />
        </div>
      </div>
      {errMessage !== "" && (
        <p
          className="normal-text"
          id="err-msg"
          style={{
            color: "#FF0000",
            display: "flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <img class="" height="15px" width="15px" src={ErrorInfo} />{" "}
          {errMessage}
        </p>
      )}

      {showFrequency && (
        <Box className="frequency-container">
          <Typography className="sub-head mb-10">
            {lang?.donationFrequency}
          </Typography>

          <FormControl fullWidth>
            <RadioGroup value={value} onChange={frequencyChange}>
              <Box className="three-box">
                {/* One Time */}
                <Box
                  className={`frequency-option ${
                    value === "one-time" ? "active-frequency" : ""
                  }`}
                >
                  <FormControlLabel
                    value="one-time"
                    control={
                      <Radio
                        sx={{
                          color: "rgba(93, 66, 148, 1)",
                          "&.Mui-checked": {
                            color: "rgba(93, 66, 148, 1)",
                          },
                        }}
                      />
                    }
                    label={
                      <Box>
                        <Typography className="sub-head">
                          {lang?.oneTime}
                        </Typography>
                        <Typography className="normal-text">
                          {lang?.oneTimeSubhead}
                        </Typography>
                      </Box>
                    }
                  />
                </Box>

                {/* Monthly */}
                <Box
                  className={`frequency-option ${
                    value === "monthly" ? "active-frequency" : ""
                  }`}
                >
                  <FormControlLabel
                    value="monthly"
                    control={
                      <Radio
                        sx={{
                          color: "rgba(93, 66, 148, 1)",
                          "&.Mui-checked": {
                            color: "rgba(93, 66, 148, 1)",
                          },
                        }}
                      />
                    }
                    label={
                      <Box>
                        <Typography className="sub-head">
                          {lang?.monthly}
                        </Typography>
                        <Typography className="normal-text">
                          {lang?.monthlySubhead}
                        </Typography>
                      </Box>
                    }
                  />
                </Box>

                {/* Quarterly */}
                <Box
                  className={`frequency-option ${
                    value === "quarterly" ? "active-frequency" : ""
                  }`}
                >
                  <FormControlLabel
                    value="quarterly"
                    control={
                      <Radio
                        sx={{
                          color: "rgba(93, 66, 148, 1)",
                          "&.Mui-checked": {
                            color: "rgba(93, 66, 148, 1)",
                          },
                        }}
                      />
                    }
                    label={
                      <Box>
                        <Typography className="sub-head">
                          {lang?.quarterly}
                        </Typography>
                        <Typography className="normal-text">
                          {lang?.quarterlySubhead}
                        </Typography>
                      </Box>
                    }
                  />
                </Box>
              </Box>
            </RadioGroup>
          </FormControl>

          {(value === "monthly" || value === "quarterly") && (
            <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginTop: 12 }}>
              <Checkbox
                checked={recurringAcknowledged}
                onChange={(e) => setRecurringAcknowledged(e.target.checked)}
                sx={{
                  padding: 0,
                  color: 'rgba(93, 66, 148, 1)',
                  '&.Mui-checked': { color: 'rgba(93, 66, 148, 1)' },
                }}
              />
              <Typography className="sub-head-1">
                {lang?.recurringCheckboxText?.replace(/\{projectName\}/g, sharedData?.projectName || '')}
              </Typography>
            </Box>
          )}
        </Box>
      )}

      <div className="mt-30 mb-30">
        <div>
          <Typography className="sub-head">
            {lang?.tipGivesomeServices}
          </Typography>
        </div>
        <div className="mt-10">
          <Typography className="sub-head-1">
            {showFrequency ? lang?.givesomeDoesNotChargeRecurring : lang?.givesomeDoesNotCharge}
          </Typography>
        </div>
        <div>
          <SliderComponent
            disabled={youGive ? false : true}
            amount={youGive ? youGive : 0.0}
            sliderValue={sliderValue}
            currencySymbol={
              currencySymbol
                ? currencySymbol
                : sharedData?.donationAmount?.currencySymbol
            }
            setCreditApplied={setCreditApplied}
            setTotalAmount={setTotalAmount}
            setSliderValue={setSliderValue}
            sharedData={sharedData}
          />
        </div>
      </div>

      <div className="flex-space-btw" style={{ marginTop: 20 }}>
        <Typography className="normal-text mb-10">
          {lang?.yourDonation}
        </Typography>
        <Typography className="normal-text">
          {currencySymbol}
          {youGive
            ? youGive.toString().includes(".")
              ? youGive
              : youGive + ".00"
            : 0.0}
        </Typography>
      </div>
      <div className="flex-space-btw">
        <Typography className="normal-text mb-10">
          {lang?.givesomeTip}
        </Typography>
        <Typography className="normal-text mb-10">
          {currencySymbol}
          {sharedData?.rewardApplied?.creditApplied
            ? sharedData?.rewardApplied?.creditApplied.toFixed(2)
            : creditApplied.toFixed(2)}
        </Typography>
      </div>
      <div className="flex-space-btw" style={{ marginBottom: 15 }}>
        <Typography className="sub-head mb-10">{lang?.total}</Typography>
        <Typography
          className="sub-head mb-10"
          style={{ textTransform: "uppercase" }}
        >
          {currency} {currencySymbol}
          {totalAmount ? totalAmount.toFixed(2) : 0.0}
        </Typography>
      </div>
      {existingSubError && (
        <p className="subscription-message mb-10">
          You have already subscribed to this project. Your recurring donation is active.
        </p>
      )}
      <Button
        className="normal-text next-btn"
        variant="contained"
        onClick={onDonationNext}
        disabled={(value === "monthly" || value === "quarterly") && !recurringAcknowledged}
      >
        {lang?.next}
      </Button>
      {/* <Button
        className="normal-text next-btn"
        variant="contained"
        sx={{ mt: 2 }}
        onClick={handleGoogleLogin}
      >
        Sign in with Google
      </Button>
      <Button
        className="normal-text next-btn"
        variant="contained"
        sx={{ mt: 2 }}
        onClick={handleFacebookLogin}
      >
        Sign in with Facebook
      </Button> */}
    </>
  );
}

export default DonationCost;

